module.exports = __webpack_public_path__ + "static/AMCHP-logo-d1ab18f4e7d2adeda3daa76ea41a5482.png";